import { useTranslation } from 'react-i18next';
import { Tag } from 'lucide-react';

import { ConfigToggleSetting } from './ConfigToggleSetting';

/**
 * Whether shoppers see product prices in the design assistant (its picks,
 * price searches and the "budget" suggestion). Off, prices are not even sent
 * to the visualizer, and the assistant says prices are on request. Vendor
 * config `shopperPrices`, on unless switched off.
 */
export const ShopperPricesSetting = () => {
    const { t } = useTranslation();
    return (
        <ConfigToggleSetting
            field="shopperPrices"
            id="shopper-prices-switch"
            icon={<Tag />}
            label={t('PRODUCT_PRICING.SETTINGS.SHOPPER_PRICES', 'Show product prices in the design assistant')}
            description={t(
                'PRODUCT_PRICING.SETTINGS.SHOPPER_PRICES_DESC',
                'Off, the assistant shows no prices and answers price questions with "prices on request".',
            )}
        />
    );
};
